/**
 * ------------------------------------------------------------------------
 * Google Tag manager
 * ------------------------------------------------------------------------
 */
(function () {
    window.dataLayer = window.dataLayer || [];

    function gtag(){dataLayer.push(arguments);}

    gtag('js', new Date());

    gtag('config', 'G-TKY0BCQVBG');
})();
